import WorkspaceLayout from "@/layouts/WorkspaceLayout.vue";
import SettingsRoutes from "./settings.routes";

export default {
  path: '/',
  meta: { title: 'Dashboard' },
  children: [
    {
      path: 'admin-dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/dashboard/index.vue'),
      meta: { title: '', auth: true }
    },
    {
      path: 'questionnaires/:type',
      name: 'questionnaires',
      component: () => import('@/views/dashboard/questionnaires/_type.vue'),
      meta: {
        title: 'Questionnaires',
        auth: true,
        permissions: { any: ['view_workspace_form_template'] },
      },
    },
    {
      path: 'workspaces',
      meta: { title: 'Workspaces' },
      children: [
        {
          path: '',
          name: 'workspaces',
          component: () => import('@/views/dashboard/workspaces/index.vue'),
          meta: { title: '', auth: true }
        },
        {
          path: ':workspace_id/edit-workspace',
          name: 'edit-workspace',
          component: () => import('@/views/dashboard/workspaces/create.vue'),
          meta: { title: '', auth: true, permissions: { any: ['edit_workspace'] } }
        },
        {
          path: 'create',
          name: 'create-workspaces',
          component: () => import('@/views/dashboard/workspaces/create.vue'),
          meta: { title: 'Create New Workspace', auth: true, permissions: { any: ['add_workspace'] } }
        },
        {
          path: ':workspace_id',
          redirect: { name: 'workspaces-dashboard' },
          name: 'workspaces-details',
          component: WorkspaceLayout,
          meta: { title: 'Workspace Details', auth: true },
          children: [
            {
              path: 'dashboard',
              name: 'workspaces-dashboard',
              component: () => import('@/views/dashboard/workspaces/_id/dashboard.vue'),
              meta: { title: '', auth: true, allowAuthenticated: true }
            },
            {
              path: 'questionnaires/:type',
              name: 'workspaces-questionnaires',
              component: () => import('@/views/dashboard/questionnaires/_type.vue'),
              meta: {
                title: 'Form Builder',
                auth: true,
                permissions: { any: ['view_workspace_form_template'] },
              },
            },
            {
              path: 'policy-tracker',
              meta: { title: 'Policy Tracker ', module: 'policy_tracker' },
              children: [
                {
                  path: '',
                  name: 'workspaces-policies',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-tracker/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Policy Tracker ',
                    auth: true,
                    permissions: { any: ['view_policy'] }
                  }
                },
                {
                  path: ':policy_id',
                  name: 'workspaces-policy-details',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-tracker/_id.vue'),
                  meta: { title: 'Policy Details', auth: true, permissions: { any: ['view_policy'] } }
                },
                {
                  path: 'add',
                  name: 'workspaces-add-policy',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-tracker/add.vue'),
                  meta: { title: 'Add Policy', auth: true, permissions: { any: ['add_policy'] } }
                },
                {
                  path: 'ai-chat',
                  name: 'workspaces-policy-ai-chat',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-tracker/ai-chat.vue'),
                  meta: { title: 'Policy Intake Assistant', auth: true, permissions: { any: ['add_policy'] } }
                },
                {
                  path: 'edit/:policy_id',
                  name: 'workspaces-edit-policy',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-tracker/add.vue'),
                  meta: { title: 'Edit Policy', auth: true, permissions: { any: ['edit_policy'] } }
                },
              ]
            },
            {
              // Demo surface for the Laravel Policy Tracker contract (catalog / applicability /
              // questions / generate / assistant). Kept separate from the existing register UI.
              path: 'policy-intelligence',
              name: 'workspaces-policy-intelligence',
              component: () => import('@/views/dashboard/workspaces/_id/policy-intelligence/index.vue'),
              meta: {
                title: 'Policy Intelligence',
                pageTitle: 'Policy Intelligence',
                auth: true,
                module: 'policy_tracker',
                permissions: { any: ['view_policy'] },
              },
            },
            {
              path: 'policy-builder',
              meta: { title: 'Policy Builder', module: 'policy_builder' },
              children: [
                // {
                //   path: '',
                //   name: 'workspaces-policy-builder',
                //   component: () => import('@/views/dashboard/workspaces/_id/policy-builder/index.vue'),
                //   meta: {
                //     title: '',
                //     pageTitle: 'Policy Builder',
                //     auth: true,
                //     permissions: { any: ['view_policy'] }
                //   }
                // },
                {
                  path: ':policy_builder_id/edit-policy-builder',
                  name: 'workspaces-edit-policy-builder',
                  component: () => import('@/views/dashboard/workspaces/_id/policy-builder/create.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['edit_policy'] } }
                },
              ]
            },
            {
              path: 'compliance-training',
              meta: { title: 'Compliance training', module: 'compliance_training' },
              children: [
                {
                  path: '',
                  name: 'compliance-training',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Compliance training',
                    auth: true,
                    permissions: { any: ['view_training'] }
                  }
                },
                {
                  path: 'templates',
                  name: 'workspaces-training-templates',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/templates.vue'),
                  meta: { title: 'Training Templates', auth: true, permissions: { any: ['view_training'] } }
                },
                {
                  path: 'templates/:template_id',
                  name: 'workspaces-training-template-details',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/templates/_id.vue'),
                  meta: { title: 'Training Template', auth: true, permissions: { any: ['view_training'] } }
                },
                {
                  path: ':training_id',
                  name: 'workspaces-training-details',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/_id.vue'),
                  meta: {
                    title: 'Compliance Training Details',
                    auth: true,
                    permissions: { any: ['view_training'] }
                  }
                },
                {
                  path: 'add',
                  name: 'workspaces-add-training',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/add.vue'),
                  meta: { title: 'Add Training', auth: true, permissions: { any: ['add_training'] } }
                },
                {
                  path: 'generate',
                  name: 'workspaces-generate-training',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/generate.vue'),
                  meta: { title: 'Automated Training Generator', auth: true, permissions: { any: ['add_training'] } }
                },
                {
                  path: 'generate-simple',
                  name: 'workspaces-generate-training-simple',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/generate-simple.vue'),
                  meta: {
                    title: 'Create Training',
                    auth: true,
                    permissions: { any: ['add_training'] },
                  },
                },
                {
                  path: ':training_id/edit',
                  name: 'workspaces-edit-training',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-training/add.vue'),
                  meta: { title: 'Edit Training', auth: true, permissions: { any: ['edit_training'] } }
                },

              ]
            },
            {
              path: 'users',
              meta: { title: 'Users', },
              children: [
                {
                  path: '',
                  name: 'workspace-users',
                  component: () => import('@/views/dashboard/workspaces/_id/users/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['view_user'] } }
                },
                {
                  path: ':user_id',
                  name: 'workspace-user-details',
                  component: () => import('@/views/dashboard/workspaces/_id/users/_id.vue'),
                  meta: { title: 'User Details', details: true, auth: true, permissions: { any: ['view_user'] } }
                },
                {
                  path: 'add',
                  name: 'workspace-add-user',
                  component: () => import('@/views/dashboard/workspaces/_id/users/add.vue'),
                  meta: { title: 'Add User', details: true, auth: true, permissions: { any: ['add_user'] } }
                },
                {
                  path: 'edit/:user_id',
                  name: 'workspace-edit-user',
                  component: () => import('@/views/dashboard/workspaces/_id/users/add.vue'),
                  meta: { title: 'Edit User', details: true, auth: true, permissions: { any: ['edit_user'] } }
                },
              ]
            },
            {
              path: 'vendor-management',
              meta: { title: 'Vendors', module: 'vendor_management' },
              children: [
                {
                  path: '',
                  name: 'workspace-vendors',
                  component: () => import('@/views/dashboard/workspaces/_id/vendor-management/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['view_vendor'] } }
                },
                {
                  path: 'add',
                  name: 'workspace-add-vendor',
                  component: () => import('@/views/dashboard/workspaces/_id/vendor-management/add.vue'),
                  meta: { title: 'Add Vendor', auth: true, permissions: { any: ['add_vendor'] } }
                },
                {
                  path: ':vendor_id',
                  name: 'workspace-vendor-details',
                  component: () => import('@/views/dashboard/workspaces/_id/vendor-management/_id.vue'),
                  meta: { title: 'Vendor Details', auth: true, permissions: { any: ['view_vendor'] } }
                },
                {
                  path: ':vendor_id/edit',
                  name: 'workspace-edit-vendor',
                  component: () => import('@/views/dashboard/workspaces/_id/vendor-management/add.vue'),
                  meta: { title: 'Edit Vendor', auth: true, permissions: { any: ['edit_vendor'] } }
                },
              ]
            },
            {
              path: 'employee-management',
              meta: { title: 'Employees', module: 'employee_management' },
              children: [
                {
                  path: '',
                  name: 'workspace-employees',
                  component: () => import('@/views/dashboard/workspaces/_id/employee-management/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['view_employee'] } }
                },
                {
                  path: 'add',
                  name: 'workspace-add-employee',
                  component: () => import('@/views/dashboard/workspaces/_id/employee-management/add.vue'),
                  meta: { title: 'Add Employee', auth: true, permissions: { any: ['add_employee'] } }
                },
                {
                  path: ':employee_id',
                  name: 'workspace-employee-details',
                  component: () => import('@/views/dashboard/workspaces/_id/employee-management/_id.vue'),
                  meta: { title: 'Employee Details', auth: true, permissions: { any: ['view_employee'] } }
                },
                {
                  path: ':employee_id/assign-document',
                  name: 'workspace-employee-assign-document',
                  component: () => import('@/views/dashboard/workspaces/_id/employee-management/assign-document.vue'),
                  meta: { title: 'Assign Document', auth: true, permissions: { any: ['assign_employee_documents'] } }
                },
                {
                  path: ':employee_id/edit',
                  name: 'workspace-edit-employee',
                  component: () => import('@/views/dashboard/workspaces/_id/employee-management/add.vue'),
                  meta: { title: 'Edit Employee', auth: true, permissions: { any: ['edit_employee'] } }
                },
              ]
            },
            {
              path: 'onboarding-parties/:type',
              meta: { title: 'Onboarding Parties' },
              children: [
                {
                  path: '',
                  name: 'workspace-onboarding-parties',
                  component: () => import('@/views/dashboard/workspaces/_id/onboarding-parties/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['edit_workspace'] } },
                },
                {
                  path: 'add',
                  name: 'workspace-add-onboarding-party',
                  component: () => import('@/views/dashboard/workspaces/_id/onboarding-parties/add.vue'),
                  meta: { title: 'Add', auth: true, permissions: { any: ['edit_workspace'] } },
                },
                {
                  path: ':party_id',
                  name: 'workspace-onboarding-party-details',
                  component: () => import('@/views/dashboard/workspaces/_id/onboarding-parties/_id.vue'),
                  meta: { title: 'Details', auth: true, permissions: { any: ['edit_workspace'] } },
                },
                {
                  path: ':party_id/edit',
                  name: 'workspace-edit-onboarding-party',
                  component: () => import('@/views/dashboard/workspaces/_id/onboarding-parties/add.vue'),
                  meta: { title: 'Edit', auth: true, permissions: { any: ['edit_workspace'] } },
                },
              ],
            },
            {
              path: 'file-management',
              meta: { title: 'File Management', module: 'file_management' },
              children: [
                {
                  path: '',
                  name: 'workspace-file-management',
                  component: () => import('@/views/dashboard/workspaces/_id/file-management/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'File Management',
                    auth: true,
                    allowAuthenticated: true
                  }
                },
              ]
            },
            {
              path: 'google-drive',
              meta: { title: 'Google Drive' },
              children: [
                {
                  path: '',
                  name: 'workspace-google-drive',
                  component: () => import('@/views/dashboard/workspaces/_id/google-drive/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Google Drive',
                    auth: true,
                    permissions: { any: ['edit_workspace'] },
                  }
                },
              ]
            },
            {
              path: 'sharing',
              meta: { title: 'Sharing Permission', },
              children: [
                {
                  path: '',
                  name: 'workspace-sharing-permission',
                  component: () => import('@/views/dashboard/workspaces/_id/sharing/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['share_data'] } }
                },
                {
                  path: 'add',
                  name: 'workspace-sharing-permission-add',
                  component: () => import('@/views/dashboard/workspaces/_id/sharing/add.vue'),
                  meta: { title: 'Add Sharing Permission', details: true, auth: true, permissions: { any: ['share_data'] } }
                },
              ]
            },
            {
              path: 'risk-assessment-categories',
              meta: { title: 'Risk Assessments Categories', },
              children: [
                {
                  path: '',
                  name: 'workspace-risk-assessment-categories',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessment-categories/index.vue'),
                  meta: { title: '', auth: true, permissions: { any: ['view_risk_assessment_category'] } }
                },
              ]
            },
            {
              path: 'approval-requests',
              meta: { title: 'Approval Requests' },
              children: [
                {
                  path: '',
                  name: 'workspace-approval-requests',
                  component: () => import('@/views/dashboard/workspaces/_id/approval-requests/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Approval Requests',
                    auth: true,
                    permissions: { any: ['view_approval_request'] },
                  },
                },
                {
                  path: ':approval_request_id',
                  name: 'workspace-approval-request-details',
                  component: () => import('@/views/dashboard/workspaces/_id/approval-requests/_id.vue'),
                  meta: {
                    title: 'Approval Request Details',
                    auth: true,
                    permissions: { any: ['view_approval_request'] },
                  },
                },
              ],
            },
            {
              path: 'join-requests',
              meta: { title: 'Join Requests' },
              children: [
                {
                  path: '',
                  name: 'workspace-join-requests',
                  component: () => import('@/views/dashboard/workspaces/_id/join-requests/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Join Requests',
                    auth: true,
                    permissions: { any: ['view_user'] },
                  },
                },
              ],
            },
            {
              path: 'feedbacks',
              meta: { title: 'Feedbacks' },
              children: [
                {
                  path: '',
                  name: 'workspace-feedbacks',
                  component: () => import('@/views/dashboard/workspaces/_id/feedbacks/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Feedbacks',
                    auth: true,
                    allowAuthenticated: true,
                  },
                },
                {
                  path: ':feedback_id',
                  name: 'workspace-feedback-details',
                  component: () => import('@/views/dashboard/workspaces/_id/feedbacks/_id.vue'),
                  meta: {
                    title: 'Feedback Details',
                    auth: true,
                    allowAuthenticated: true,
                  },
                },
              ],
            },
            {
              path: 'document-templates',
              meta: { title: 'Document Templates' },
              children: [
                {
                  path: '',
                  name: 'workspace-document-templates',
                  component: () => import('@/views/dashboard/workspaces/_id/document-templates/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Document Templates',
                    auth: true,
                    permissions: { any: ['assign_employee_documents'] },
                  },
                },
                {
                  path: 'add',
                  name: 'workspace-add-document-template',
                  component: () => import('@/views/dashboard/workspaces/_id/document-templates/add.vue'),
                  meta: {
                    title: 'Create Document Template',
                    auth: true,
                    permissions: { any: ['assign_employee_documents'] },
                  },
                },
                {
                  path: 'signature-requests',
                  name: 'workspace-signature-requests',
                  component: () => import('@/views/dashboard/workspaces/_id/document-templates/signature-requests.vue'),
                  meta: {
                    title: 'Signature Requests',
                    auth: true,
                    permissions: { any: ['assign_employee_documents'] },
                  },
                },
                {
                  path: 'signature-requests/:request_id',
                  name: 'workspace-signature-request',
                  component: () => import('@/views/dashboard/workspaces/_id/document-templates/signature-request.vue'),
                  meta: {
                    title: 'Signature Request',
                    auth: true,
                    permissions: { any: ['assign_employee_documents'] },
                  },
                },
                {
                  path: ':template_id/edit',
                  name: 'workspace-edit-document-template',
                  component: () => import('@/views/dashboard/workspaces/_id/document-templates/add.vue'),
                  meta: {
                    title: 'Edit Document Template',
                    auth: true,
                    permissions: { any: ['assign_employee_documents'] },
                  },
                },
              ],
            },
            {
              path: 'workspace-settings',
              name: 'workspace-settings',
              component: () => import('@/views/dashboard/workspaces/_id/settings.vue'),
              meta: { title: 'Workspace Settings', auth: true, permissions: { any: ['edit_workspace'] } }
            },
            {
              path: 'reporting',
              meta: { title: 'Reporting', module: 'reporting' },
              children: [
                {
                  path: '',
                  name: 'workspace-reporting',
                  component: () => import('@/views/dashboard/workspaces/_id/reporting/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Reporting',
                    auth: true,
                    permissions: { any: ['view_reporting'] }
                  }
                },
                {
                  path: ':report_id',
                  name: 'workspace-report-detail',
                  component: () => import('@/views/dashboard/workspaces/_id/reporting/_id.vue'),
                  meta: {
                    title: 'Report Details',
                    auth: true,
                    permissions: { any: ['view_reporting'] }
                  }
                },
              ]
            },
            {
              path: 'alerts',
              name: 'workspace-alerts',
              component: () => import('@/views/dashboard/workspaces/_id/alerts/index.vue'),
              meta: {
                title: '',
                pageTitle: 'Reminders & Alerts',
                auth: true,
                allowAuthenticated: true,
              },
            },
            {
              path: 'compliance-action-center',
              meta: { title: 'Compliance Action Center', module: 'compliance_action_center' },
              children: [
                {
                  path: '',
                  name: 'workspace-compliance-action-center',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-action-center/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Compliance Action Center',
                    auth: true,
                    permissions: { any: ['view_compliance_alert'] }
                  }
                },
                {
                  path: ':alert_id',
                  name: 'workspace-compliance-alert-details',
                  component: () => import('@/views/dashboard/workspaces/_id/compliance-action-center/_id.vue'),
                  meta: {
                    title: 'Alert Details',
                    auth: true,
                    permissions: { any: ['view_compliance_alert'] }
                  }
                },
              ]
            },
            {
              path: 'risk-assessments',
              meta: { title: 'Risk Assessments' },
              children: [
                {
                  path: '',
                  name: 'workspace-risk-assessments',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Risk Assessments',
                    auth: true,
                    permissions: { any: ['view_risk_assessment'] }
                  }
                },
                {
                  path: 'add',
                  name: 'workspace-add-risk-assessment',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/add.vue'),
                  meta: { title: 'Add Risk Assessment', auth: true, permissions: { any: ['add_risk_assessment'] } }
                },
                {
                  path: ':risk_assessment_id',
                  name: 'workspace-risk-assessment-details',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/_id.vue'),
                  meta: { title: 'Risk Assessment Details', auth: true, permissions: { any: ['view_risk_assessment'] } }
                },
                {
                  path: ':risk_assessment_id/edit',
                  name: 'workspace-edit-risk-assessment',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/add.vue'),
                  meta: { title: 'Edit Risk Assessment', auth: true, permissions: { any: ['edit_risk_assessment'] } }
                },
                {
                  path: ':risk_assessment_id/report',
                  name: 'workspace-risk-assessment-report',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/[id]/report.vue'),
                  meta: { title: 'Risk Assessment Report', auth: true, permissions: { any: ['view_risk_assessment'] } }
                },

                {
                  path: 'risk-assessment-questionnaire',
                  name: 'workspaces-risk-assessment-questionnaire',
                  component: () => import('@/views/dashboard/workspaces/_id/risk-assessments/questionnaire.vue'),
                  meta: { title: 'Risk Assessment Questionnaire', auth: true, permissions: { any: ['view_risk_assessment'] } }
                },
              ]
            },
            {
              path: 'audits',
              meta: { title: 'Audits', module: 'audits' },
              children: [
                {
                  path: '',
                  name: 'workspace-audits',
                  component: () => import('@/views/dashboard/workspaces/_id/audits/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Audits',
                    auth: true,
                    permissions: { any: ['view_audit'] },
                  },
                },
                {
                  path: ':audit_id',
                  name: 'workspace-audit-details',
                  component: () => import('@/views/dashboard/workspaces/_id/audits/_id.vue'),
                  meta: {
                    title: 'Audit Details',
                    auth: true,
                    permissions: { any: ['view_audit'] },
                  },
                },
                {
                  path: ':audit_id/evidence',
                  name: 'workspace-audit-evidence',
                  component: () => import('@/views/dashboard/workspaces/_id/audits/evidence.vue'),
                  meta: {
                    title: 'Submit Audit Evidence',
                    auth: true,
                    permissions: { any: ['edit_audit'] },
                  },
                },
              ],
            },
            {
              path: 'audit-templates',
              meta: { title: 'Audit Templates', module: 'audits' },
              children: [
                {
                  path: '',
                  name: 'workspace-audit-templates',
                  component: () => import('@/views/dashboard/workspaces/_id/audit-templates/index.vue'),
                  meta: {
                    title: '',
                    pageTitle: 'Audit Templates',
                    auth: true,
                    permissions: { any: ['view_audit', 'view_audit_template'] },
                  },
                },
                {
                  path: 'add',
                  name: 'workspace-add-audit-template',
                  component: () => import('@/views/dashboard/workspaces/_id/audit-templates/add.vue'),
                  meta: {
                    title: 'Create Audit Template',
                    auth: true,
                    permissions: { any: ['add_audit_template', 'add_audit'] },
                  },
                },
                {
                  path: ':template_id/edit',
                  name: 'workspace-edit-audit-template',
                  component: () => import('@/views/dashboard/workspaces/_id/audit-templates/add.vue'),
                  meta: {
                    title: 'Edit Audit Template',
                    auth: true,
                    permissions: { any: ['edit_audit_template', 'edit_audit'] },
                  },
                },
              ],
            },

          ]
        },
      ]
    },
    SettingsRoutes,
    {
      path: 'inquiries',
      name: 'inquiries',
      component: () => import('@/views/dashboard/inquiries/index.vue'),
      meta: { title: 'Inquiries', auth: true }
    },
    {
      path: 'profile',
      name: 'profile-settings',
      component: () => import('@/views/dashboard/settings/profile.vue'),
      meta: { title: 'Profile Settings', pageTitle: 'Profile Settings', auth: true, allowAuthenticated: true }
    },
  ]
}



